import { render, staticRenderFns } from "./PortfolioCard.vue?vue&type=template&id=2c266888&scoped=true&"
import script from "./PortfolioCard.vue?vue&type=script&lang=js&"
export * from "./PortfolioCard.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioCard.vue?vue&type=style&index=0&id=2c266888&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c266888",
  null
  
)

export default component.exports